import { useState } from "react";
import { searchBoard } from "./board-search";
import { Search } from "lucide-react";
import type { WorkspaceModel } from "./useWorkspace";

export function BoardSearch({
  model,
  close,
}: {
  model: WorkspaceModel;
  close: () => void;
}) {
  const [query, setQuery] = useState("");
  const term = query.trim().toLocaleLowerCase();
  const results = searchBoard(model.editor, model.shapes, query);
  return (
    <div className="board-search">
      <label>
        <Search size={17} />
        <input
          autoFocus
          aria-label="Search this board"
          placeholder="Find a sheet, note or object…"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
      </label>
      <div className="board-search-results" aria-live="polite">
        {!term ? (
          <p>Search names and text on this board.</p>
        ) : !results.length ? (
          <p>No matches for “{query}”.</p>
        ) : (
          <>
            <small>
              {results.length} {results.length === 1 ? "result" : "results"}
            </small>
            {results.slice(0, 50).map(({ shape, label }) => (
              <button
                key={shape.id}
                onClick={() => {
                  model.choose("select");
                  model.editor.select(shape.id);
                  const bounds = model.editor.getShapePageBounds(shape);
                  if (bounds)
                    model.editor.zoomToBounds(bounds, {
                      inset: 180,
                      animation: { duration: 200 },
                    });
                  close();
                }}
              >
                <span>{label}</span>
                <small>{shape.type}</small>
              </button>
            ))}
            {results.length > 50 && (
              <p>Showing the first 50; refine your search to find more.</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
